import { NUMBER } from "./app-constants";

export const LIST_THRESHOLD_LIMIT_MSITE = NUMBER.FIVE;
export const LIST_THRESHOLD_LIMIT = NUMBER.FIFTEEN;

export const PAGE_TYPES = {
    HOME: "rto_home",
    STATE: "rto_state",
    RTO: "rto"
};

export const PAGE_KEY_MAPPING = {
    [PAGE_TYPES.HOME]: "state",
    [PAGE_TYPES.STATE]: "state",
    [PAGE_TYPES.RTO]: "state"
};

export const RTO_DETAILS = {
    headers: ["RTO office", "RTO code"],
    columnKeys: {name: "name", value: "code"}
};

export const VEHICLE_DETAILS = {
    headers: ["Year", "Vehicle registration"],
    columnKeys: {name: "year", value: "vehicleRegCount"}
};

export const FUEL_PRICE_TREND = {
    INCREASED: "INCREASED",
    DECREASED: "DECREASED"
};
export const RTO = "rto";
